export const oneTrust = {
  id: "0192017e-99ef-7fad-a6da-dab614ac86b3",
  multiProgram: "01922990-e4ac-7ba5-b051-ba7e05265503",
};